export default __webpack_public_path__ + "static/media/logo.865ed1bc.svg";